<template>
  <div class="logo"><!--:style="{'background-image':`url(${require('@/assets/header-left-image.png')})`}"-->
    <a-icon type="menu-fold"  style="margin-right: 20px;color: white;" @click="handleClick()"/>
<!--    <router-link @click="routerLinkTo" style='flex: 1'>-->
    <a  style='flex: 1;margin-right: 20px;'>
      <!--<a-icon type="menu-fold" style="margin-right: 30px" @click="handleClick()"/>-->
      <!-- update-begin- author:sunjianlei --- date:20190814 --- for: logo颜色根据主题颜色变化 -->
      <!--<img v-if="navTheme === 'dark'" src="~@/assets/logo.svg" alt="logo" @click="gotoPortal()">
      <img v-else src="~@/assets/logo-sp365-light.svg" alt="logo" @click="gotoPortal()">-->
      <!-- update-begin- author:sunjianlei --- date:20190814 --- for: logo颜色根据主题颜色变化 -->

     <!-- <a-drawer
        title="切换到其它系统"
        :placement="placement"
        :closable="false"
        :visible="visible"
        @close="onClose"
       >
        <template>
          <a-list item-layout="horizontal" :data-source="dataSource">
            <a-list-item slot="renderItem" slot-scope="item, index">
              <a-list-item-meta
              >
                <a slot="title" @click="handleJump(item.applicationCode)">{{ item.applicationName }}</a>
                <a-avatar
                  slot="avatar"
                  src=""
                />
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </template>
      </a-drawer>-->

<!--      <h1 v-if="showTitle">{{ title }}</h1>-->
    </a>

    <a-drawer
      :title='this.$store.getters.language["system.switchSystem"]'
      :placement="placement"
      :closable="false"
      :visible="visible"
      @close="onClose"
    >
      <template>
        <a-list item-layout="horizontal" :data-source="dataSource">
          <a-list-item slot="renderItem" slot-scope="item, index">
            <a-list-item-meta
            >
              <a slot="title" @click="handleJump(item)">{{ item.applicationNameLanguage?item.applicationNameLanguage:item.applicationName }}</a>
              <a-avatar
                slot="avatar"
                :src="getAvatarView(item.applicationImgPath)"
              />
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </template>
    </a-drawer>
  </div>
</template>

<script>
  import { mapActions, mapMutations, mapGetters,mapState } from 'vuex'
  import { mixin } from '@/utils/mixin.js'
  import {getAction,getFileAccessHttpUrl} from '@/api/manage';
  import { queryPermissionsByUser } from '@/api/api'
  import Vue from 'vue'
  import { APPLICATION_CODE } from "@/store/mutation-types"
  import store from "../../store";

  export default {
    name: 'Logo',
    mixins: [mixin],
    props: {
      title: {
        type: String,
        default: 'Foxconn',
        required: false
      },
      showTitle: {
        type: Boolean,
        default: true,
        required: false
      },
      // 点击Logo跳转地址
      /*routerLinkTo: {
        type: Object,
        default: () => ({name: 'dashboard'}),
      },*/
    },
    data() {
      return {
        uploadSource:"platform",
        visible: false,
        placement: 'left',
        list: "/sys/sysBmApplication/queryListByUser",
        parm:{
          pageNo:1,
          pageSize:10
        },
        dataSource:[],
      }
    },
    mounted () {
      getAction(this.list).then(res => {
        if (res.success) {
          this.dataSource = res.result
        }
      })
    },
    computed: {
      ...mapState({
        // 后台菜单
        permissionMenuList: state => state.user.permissionList

      }),
      ...mapGetters(["nickname", "avatar","userInfo"]),
    },
    methods : {
      routerLinkTo(){
        window.open(process.env.VUE_APP_LOGIN_OUT_PATH);
      },
      getAvatarView: function (avatar) {
        return getFileAccessHttpUrl(avatar,this.uploadSource)
      },
      ...mapActions([""]),
      ...mapMutations(['addAge']),
      handleClick() {
        this.visible = true;
      },
      async handleJump(item) {
        await this.setLangCode(item.applicationCode)
        // this.$store.commit('SET_APPLICATION',item);
        getAction("/sys/sysBmApplication/queryByCode", {code:item.applicationCode}).then((res) => {
          if (res.success) {
            this.$store.commit('SET_IS_CLICK', true)
            this.getAction(item.applicationCode)
            this.$store.commit('SET_APPLICATION',res.result);
            this.$emit('applicationChange');
            this.onClose()
          }
        })

      },
      async setLangCode(appCode){
        await getAction("/sys/sysBmApplication/queryLanguageByCode",{code:appCode}).then(res=> {
          if (res.success) {
            let languageSettings = res.result
            let langCode = window.sessionStorage.getItem('USER_LANGUAGE');
            if (languageSettings) {
              let languages = languageSettings.split(",");
              if (languageSettings.indexOf(langCode) == -1) {
                // window.sessionStorage.setItem('USER_LANGUAGE', languages[0]);
                store.dispatch('GetLanguage',languages[0])
              }
            }
          }
        })
      },
      async getAction(applicationCode) {
        // await this.setLangCode(applicationCode)
        getAction(this.list).then(res => {
          if (res.success) {
            this.dataSource = res.result
          }
        })

        queryPermissionsByUser({applicationCode}).then(response => {

          let menuData = response.result.menu;
          const authData = response.result.auth;
          const allAuthData = response.result.allAuth;
         // Vue.ls.set(APPLICATION_CODE, applicationCode);
          this.$store.commit('SET_CHANGE_SYS', true)
          this.$store.commit('SET_APPLICATION_CODE', applicationCode)

          sessionStorage.setItem(APPLICATION_CODE,applicationCode);

          console.log('foxconn menuData',menuData)

          if (menuData === null || menuData === "" || menuData === undefined || menuData.length === 0) {

            this.$notification.error({
                           message: '系统提示',
                           description: '没有应用权限'
                         })
            this.$store.commit('SET_PERMISSIONLIST', menuData)
            this.$forceUpdate();
            return;
          }

          //Vue.ls.set(USER_AUTH,authData);
          /*sessionStorage.setItem(USER_AUTH,JSON.stringify(authData));
          sessionStorage.setItem(SYS_BUTTON_AUTH,JSON.stringify(allAuthData));*/
          if (menuData && menuData.length > 0) {
            //一级菜单的子菜单全部是隐藏路由，则一级菜单不显示------
            menuData.forEach((item, index) => {
              if (item["children"]) {
                let hasChildrenMenu = item["children"].filter((i) => {
                  return !i.hidden || i.hidden == false
                })
                if (hasChildrenMenu == null || hasChildrenMenu.length == 0) {
                  item["hidden"] = true
                }
              }
            })
            this.$store.commit('SET_PERMISSIONLIST', menuData)
            
            this.$forceUpdate();
          } else {
        //    reject('getPermissionList: permissions must be a non-null array !')
          }
        //  resolve(response)
        }).catch(error => {
         // reject(error)
        })
      },
      onClose() {
        this.visible = false;

      },
      gotoPortal(){
        window.location.href=process.env.VUE_APP_LOGIN_OUT_PATH;
      }
    }
  }
</script>
<style lang="less" scoped>
  /*缩小首页布 局顶部的高度*/
  @height: 59px;

  .sider {
    box-shadow: none !important;
    .logo {
      height: @height !important;
      line-height: @height !important;
      box-shadow: none !important;
      transition: background 300ms;

      a {
        color: white;
        &:hover {
          color: rgba(255, 255, 255, 0.8);
        }
      }
    }

    &.light .logo {
      background-color: #0d2477;
      background-size: cover;
    }
  }

</style>